import axios from 'axios';
const service = axios.create({
  baseURL: '/api', // 设置基础URL
  timeout: 500000 // 设置请求超时时间
});
service.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem("token");
    if(token){
      config.headers["Authorization"]= "Bearer "+token;
    }
    return config;
  },
  error =>{
    console.error(error);
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  response=>{
    return response.data;
  },
  error =>{
    const { response }= error
    //攔截401，登入過久確認Refresh Token是否過期，未過期回傳token給前端使用
    if(response && response.status === 401){

      const refresh_token = window.localStorage.getItem("refresh_token");
      axios.post("/api/Auth/ReloadToken", null, {
      headers: {
          'Authorization' : 'Bearer '+refresh_token,
          'Content-Type': 'multipart/form-data'
      }
      }).then((res) => {
          var tokenObj = JSON.parse(res.data.data);
          window.localStorage.setItem("isLogin", true);
          window.localStorage.setItem("token", tokenObj["token"]);
          window.localStorage.setItem("refresh_token", tokenObj["refresh_token"]);
          window.localStorage.setItem("username", tokenObj["userName"]);
          console.log("***88888***");
          console.log(tokenObj["userName"]);
      }).catch((err) => {
        console.error(err);
        handle401Error();
      })
    }
    console.log(error);
    return null;
    //return Promise.reject("閒置過久，需重新抓取登入資料，請重新操作一次");
  }
);
function handle401Error() {
  localStorage.clear();
  location.href="/";
}
export default service;